import request from "@utils/request";

export function fetchTakerData(query) {
    return request({
        url: "lp/eod-position/taker",
        method: "post",
        data: query,
    });
}

export function fetchMakerData(query) {
    return request({
        url: "lp/eod-position/maker",
        method: "post",
        data: query,
    });
}
